<div mat-dialog-title>
  <h2 class="card-title">Unflag Decision #{{ data.decisionNumber }}</h2>
</div>

<mat-dialog-content class="content">
    <div class="warning-section warning">
      <div class="icon">
        <mat-icon>info</mat-icon>
      </div>
      <div>
        <strong>Warning:</strong> Only remove if flagged in error.
        <br>
        <br>
        This action will also remove the follow-up date and explanatory text
        associated with the flag and cannot be undone.
        <br>
        <br>
        Are you sure you want to remove the Flag?
      </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="button-container">
    <button mat-stroked-button color="primary" [mat-dialog-close]="{ save: false }">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="save()">
      Yes
    </button>
  </div>
</mat-dialog-actions>
